import React, { useRef, useEffect, useState } from 'react';
import FullCalendar from '@fullcalendar/react';
// import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid'; // <-- LO QUITAMOS
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import { Paper, Box, Typography, CircularProgress, Alert } from '@mui/material';
import moment from 'moment'; 

// Controller
import { getCalendarResources, getCalendarEvents, updateBookingDrop } from '../../../controllers/company/MerchantBookingController';

export default function MerchantCalendar({ 
    onEventClick, 
    targetDate, 
    filters,    
    onResourcesLoaded 
}) {
    const calendarRef = useRef(null);
    const [resources, setResources] = useState([]);
    const [loadingResources, setLoadingResources] = useState(true);
    const [error, setError] = useState(null);

    // 1. Cargar recursos (Los seguimos cargando para enviarlos a los filtros)
    useEffect(() => {
        loadResources();
    }, []);

    const loadResources = async () => {
        try {
            setLoadingResources(true);
            const data = await getCalendarResources();
            const resList = Array.isArray(data) ? data : [];
            setResources(resList);
            if (onResourcesLoaded) onResourcesLoaded(resList);
        } catch (err) {
            console.error(err);
            setError("Error cargando recursos");
        } finally {
            setLoadingResources(false);
        }
    };

    // 2. Saltar a fecha
    useEffect(() => {
        if (targetDate && calendarRef.current) {
            calendarRef.current.getApi().gotoDate(targetDate);
        }
    }, [targetDate]);

    // 3. Refrescar eventos al cambiar filtros
    useEffect(() => {
        if (calendarRef.current) {
            calendarRef.current.getApi().refetchEvents();
        }
    }, [filters]);

    // 4. Fetch Events
    const fetchEvents = async (info, successCallback, failureCallback) => {
        try {
            const events = await getCalendarEvents(info, filters); 
            successCallback(Array.isArray(events) ? events : []);
        } catch (error) {
            failureCallback(error);
        }
    };

    // 5. Drag & Drop (Ajustado para calendario estándar)
    const handleEventDrop = async (info) => {
        const { event, revert } = info;
        const uuid = event.id;

        const newStart = moment(event.start).format('YYYY-MM-DD HH:mm:ss');
        const endDateObj = event.end ? event.end : moment(event.start).add(1, 'hours').toDate();
        const newEnd = moment(endDateObj).format('YYYY-MM-DD HH:mm:ss');

        // Como ya no arrastramos entre columnas de recursos, mantenemos el recurso original.
        // Lo sacamos de los extendedProps que enviaste desde el backend.
        const resourceId = event.extendedProps.employee_id || event.extendedProps.resourceId || null;

        console.log("Moviendo a:", newStart, newEnd); 

        try {
            await updateBookingDrop(uuid, newStart, newEnd, resourceId);
        } catch (error) {
            alert("No se pudo mover la cita.");
            revert(); 
        }
    };

    if (loadingResources) return <Box p={5} textAlign="center"><CircularProgress /></Box>;
    if (error) return <Box p={2}><Alert severity="error">{error}</Alert></Box>;

    return (
        <Paper sx={{ p: 2, borderRadius: 3, height: '80vh', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
            <FullCalendar
                ref={calendarRef}
                key={resources.length}
                // Usamos solo los plugins estándar (Mes, Semana, Día)
                plugins={[ dayGridPlugin, timeGridPlugin, interactionPlugin ]}
                initialView="timeGridWeek" // Vista por defecto: Semana Normal
                locale="es"
                timeZone="local"
                slotMinTime="07:00:00"
                slotMaxTime="21:00:00"
                allDaySlot={false}
                
                headerToolbar={{
                    left: 'prev,next today',
                    center: 'title',
                    // Agregamos las vistas clásicas
                    right: 'dayGridMonth,timeGridWeek,timeGridDay' 
                }}
                
                // resources={resources} <-- ELIMINADO: Ya no creamos columnas
                events={fetchEvents}
                
                editable={true}
                droppable={true}
                eventDrop={handleEventDrop}
                eventClick={(info) => onEventClick(info.event)}
                eventContent={renderEventContent}
                height="100%"
                nowIndicator={true}
            />
        </Paper>
    );
}

// 6. Tarjeta del Evento (Modificada para mostrar el profesional)
function renderEventContent(eventInfo) {
    const props = eventInfo.event.extendedProps;
    return (
        <Box sx={{ p: 0.5, lineHeight: 1.2, overflow: 'hidden' }}>
            <Typography variant="caption" display="block" fontWeight="bold" sx={{ fontSize: '0.7rem' }}>
                {eventInfo.timeText}
            </Typography>
            
            <Typography variant="body2" fontWeight="bold" sx={{ fontSize: '0.8rem' }}>
                {props.client_name}
            </Typography>
            
            {/* NUEVO: Mostrar el nombre del profesional ya que no hay columnas */}
            <Typography variant="caption" display="block" sx={{ fontSize: '0.7rem', color: '#fff', fontWeight: 'bold', mt: 0.5 }}>
                👤 {props.employee_name || props.resourceName || 'Por Asignar'}
            </Typography>
            
            <Typography variant="caption" display="block" sx={{ fontSize: '0.65rem', opacity: 0.9 }}>
                ✂️ {props.service_name}
            </Typography>
            
            {props.status === 'pending' && (
                <Box sx={{ bgcolor: 'rgba(0,0,0,0.3)', borderRadius: 0.5, px: 0.5, mt: 0.5, display: 'inline-block' }}>
                     <Typography variant="caption" sx={{ color: '#fff', fontWeight:'bold', fontSize: '0.6rem' }}>
                        ⚠️ PENDIENTE
                    </Typography>
                </Box>
            )}
        </Box>
    );
}